import PropTypes from 'prop-types';

import { theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';

import { breakpoints } from 'Components/ThemeProvider';
import { Typography } from 'Components/Typography';

import useMedia from 'utils/useMedia';

const IntroHeroWrapper = styled('div')`
  display: flex;
  flex-direction: column;

  ${legacyTheme.breakpoints.up('md')} {
    flex-direction: row;
  }
`;

const IntroHeroImage = styled('div')`
  position: absolute;
  width: 100vw;
  height: 375px;
  background-image: ${({ image }) => `url(${image.mobile.src})`};
  background-size: cover;
  background-position: center;

  ${legacyTheme.breakpoints.up('sm')} {
    background-image: ${({ image }) => `url(${image.tablet.src})`};
  }

  ${legacyTheme.breakpoints.up('md')} {
    width: 50%;
    height: ${props => (props.isRoutine ? '411px' : '600px')};
    position: relative;
    top: initial;
    background-image: ${({ image }) => `url(${image.desktop.src})`};
  }
`;

const TitleCard = styled('div')`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 90%;
  margin: 225px auto 0 auto;
  height: ${props => (props.isRoutine ? '300px' : 'auto')};
  padding: ${props => (props.isRoutine ? '63px 2px 34px' : '43px 19px 34px')};
  font-family: ${legacyTheme.typography.simplonNorm};
  font-weight: normal;
  font-size: 16px;

  background-color: ${theme.colors.neutral[100]};
  border-top-right-radius: 15px;
  border-top-left-radius: 15px;

  text-align: center;

  h3 {
    font-family: ${legacyTheme.typography.saol};
    font-weight: normal;
    font-size: 30px;
    margin: 0;
    padding: 0 5px;

    span {
      font-style: italic;
      color: ${theme.colors.primary[400]};
    }
  }

  ${legacyTheme.breakpoints.up('md')} {
    position: relative;
    top: initial;
    left: initial;
    transform: none;
    width: 50%;
    height: ${props => (props.isRoutine ? '411px' : '600px')};
    margin: 0 auto;
  }
`;

const StyledDesccription = styled(Typography)`
  padding: 20px 0;

  ${legacyTheme.breakpoints.up('sm')} {
    padding: 20px 60px;
  }

  ${legacyTheme.breakpoints.up('md')} {
    width: 80%;
    padding: 20px 0 25px 0;
  }
`;

const IntroHero = ({ title, description, imageSet, isRoutine, children }) => {
  const isDesktop = useMedia(`(min-width: ${breakpoints.md}px)`);

  return (
    <IntroHeroWrapper isRoutine={isRoutine}>
      <IntroHeroImage data-testid="formula-hero" image={imageSet} isRoutine={isRoutine} />

      {!isDesktop && (
        <TitleCard isRoutine={isRoutine}>
          <h3>{title}</h3>
          <StyledDesccription>{description}</StyledDesccription>

          {children}
        </TitleCard>
      )}

      {isDesktop && (
        <TitleCard isRoutine={isRoutine}>
          <h3>{title}</h3>
          <StyledDesccription>{description}</StyledDesccription>
          {children}
        </TitleCard>
      )}
    </IntroHeroWrapper>
  );
};

IntroHero.defaultProps = {
  isRoutine: false,
  children: null,
};

IntroHero.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  description: PropTypes.string.isRequired,
  imageSet: PropTypes.shape({}).isRequired,
  isRoutine: PropTypes.bool,
  children: PropTypes.node,
};

export default IntroHero;
